import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getWebview } from '@cian/webview/webview';
import { getTelemetry } from '@cian/telemetry/browser';
import { registry as getMicrofrontendsRegistry } from '@cian/mf-registry/browser';
import { IAppContext, IAppContextCustom, createAppEvent } from '../../../shared/AppModulesWrapper';
import { getWebviewDummy } from '../../../shared/Webview/utils/getWebviewDummy';
import { DEFAULT_PAYMENT_SOURCE } from '../../../shared/ServicePickerWidget/constants/context';
import { getPaymentWidgetMicrofrontendAPI } from '../../../shared/PaymentWidgetMicrofrontend';
import { getPayPackageMicrofrontendAPI } from '../../../shared/PayPackageMicrofrontend';

interface ICreateContextParams {
  isMicrofrontend?: boolean;
}

export const createContext = (params: ICreateContextParams = {}): IAppContext => {
  const config = getConfig();
  const logger = getLogger();
  const telemetry = getTelemetry();
  const { isMicrofrontend = false } = params;

  const custom = config.get<IAppContextCustom>('applicationContext.custom') || ({} as IAppContextCustom);
  const paymentInitSource = config.get<string>('paymentInitSource') || DEFAULT_PAYMENT_SOURCE;
  const isWebview = !!config.get<boolean>('web.isWebView');

  const webview = isWebview ? getWebview() : getWebviewDummy();

  const appEvent = createAppEvent(isMicrofrontend);

  const microfrontendsRegistry = getMicrofrontendsRegistry();

  const paymentWidgetMicrofrontend = getPaymentWidgetMicrofrontendAPI({ logger, microfrontendsRegistry });
  const payPackageMicrofrontend = getPayPackageMicrofrontendAPI({ logger, microfrontendsRegistry });

  return {
    config,
    logger,
    httpApi: getHttpApi(),
    custom,
    webview,
    telemetry,
    isMicrofrontend,
    paymentInitSource,
    paymentWidgetMicrofrontend,
    appEvent,
    microfrontendsRegistry,
    payPackageMicrofrontend,
  };
};
